import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IUsersDropdown } from "../../../models/IDropdown";
import { Fetch } from "../../../shared/Fetch";
import { Dropdown } from "primereact/dropdown";
import { AnyARecord } from "dns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface ITableRow {
    id: number;
    contact_Person_ID?: number;
    sales_ID_Have_Contact_Person?: number
}
interface IProps {
    tableData: ITableRow[],
    open: boolean,
    hideDialoge: () => void,
    toast: any
}

interface formSchema {
    total_Recived_Amount: number,
    paymentStatus: string,
    payment_Mode: string,
    transaction_ID: string,
}

const schema = yup.object({
});

export const AssignedSalesForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [salesManager, setSalesManager] = useState<Array<IUsersDropdown>>();
    const [selectedSM, setSelectedSM] = useState<any | null>(null);
    const [failedList, setFailedList] = useState<any[]>([]); 

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<formSchema>({
        resolver: yupResolver(schema),
        shouldFocusError: false
    });

    const onHide = () => {
        props.hideDialoge();
        setSelectedSM([])
        setFailedList([])
    }

    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSalesManager(data);
        }
    }
    // const saveToDB = async (body: any) => {
    //     let hasError = false;

    //     for (const item of props.tableData) {
    //         const payload = {
    //             salesManager_ID: selectedSM,
    //             contact_Person_ID: item.contact_Person_ID,
    //             sales_ID_Have_Contact_Person: item.sales_ID_Have_Contact_Person
    //         };

    //         const response = await Fetch("InActivePrimeVendor/AssignedSales", "POST", payload, null, props.toast);
    //         if (response) {
    //             let xyzData: any = await response.json();
    //             if (xyzData?.type == 1) {
    //                 hasError = true;
    //                 props.toast.current.show({ severity: 'error', detail: xyzData.message, life: 3000 });
    //                 break;
    //             }
    //         } else {
    //             hasError = true;
    //             props.toast.current.show({
    //                 severity: 'error',
    //                 detail: "Can not be transferred as this POC is already with this SalesManager",
    //                 life: 3000
    //             });

    //             break;

    //         }
    //     }

    //     setLoading(false);

    //     if (!hasError) {
    //         props.toast.current.show({
    //             severity: 'success',
    //             detail: "Sales Assigned Successfully",
    //             life: 3000
    //         });
    //         onHide();

    //     }

    // };
    const saveToDB = async (data: any) => {
        setLoading(true);
        const payload = props.tableData.map((item: any) => ({
            contact_Person_ID: item.contact_Person_ID,
            salesManager_ID: selectedSM,
            sales_ID_Have_Contact_Person: item.sales_ID_Have_Contact_Person,
        }));
        const response = await Fetch("InActivePrimeVendor/AssignedSales", "POST", payload, null, props.toast);
        if (response) {
            const res = await response.json();
            const results = res.results || [];
            const notAssigned = res.notAssignedContactPersons || [];
            const success = results.filter((r: any) => r.success);
            const failed = results.filter((r: any) => !r.success);

            setFailedList(failed.map((f: any) => ({
                name: f.contact_Person_Name,
                reason: f.message
            })));

            let message = "";
            if (success.length > 0) {
                message += `${success.length} contact person(s) assigned successfully`;
            }
            if (failed.length > 0) {
                message += success.length > 0 ? ", " : "";
                message += `${failed.length} failed:\n`;
                message += failed
                    .map(
                        (f: any, i: number) =>
                            `${i + 1}. ${f.contact_Person_Name}: ${f.message}`
                    )
                    .join("\n");
            }
            if (failed.length === 0) {
                setTimeout(() => {
                    onHide();
                    setFailedList([])
                }, 800);
            }


            props.toast.current.show({ severity: failed.length > 0 ? "warn" : "success", detail: message, life: 5000, });
        }
        setLoading(false);
    };





    const onSubmitBulk = async (data: any) => {
        saveToDB(data)
    };

    useEffect(() => {
        if (props.open) {
            loadSales(0, 0, 0)
        };
    }, [props.open]);

    return (
        <>
            <Dialog style={{ width: '40vw' }} visible={props.open} onHide={() => onHide()} header="Assign To Sales Manager" >
                <form onSubmit={handleSubmit(onSubmitBulk)} className="p-fluid formgrid grid" >
                    {/* <JVDropdown column={1} label="Sales Manager" control={control} name="salesManager_ID" options={salesManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
                    <div style={{ width: '100%', marginLeft: '10px', marginBottom: '10px' }} >
                        <label className="" style={{ display: 'block', marginBottom: '8px' }}>Sales Manager</label>
                        <Dropdown value={selectedSM} onChange={(e) => {
                            setSelectedSM(e.value);
                        }} options={salesManager} optionLabel="user_Name" placeholder="Select SM" optionValue="login_ID"
                            filter className="w-full" />
                    </div>
                    <Button label="Assign" type="submit" loading={loading} />
                    {/*  Show failed contacts inside dialog */}
                    {failedList.length > 0 && (
                        <div className="mt-3 p-3 border-round bg-red-50">
                            <h5 className="text-red-600 mb-3">
                                Failed to Assign ({failedList.length})
                            </h5>
                            <DataTable
                                value={failedList.map((f, index) => ({ id: index + 1, name: f.name, reason: f.reason }))}
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                            >
                                <Column field="id" header="#" style={{ width: "50px" }} />
                                <Column field="name" header="Contact Person Name" />
                                <Column field="reason" header="Reason" />
                            </DataTable>
                        </div>
                    )}
                </form>
            </Dialog>


        </>
    );
}